<template>
  <div class="col-lg-3 col-md-6 col-12 folovid__col mb-3">
    <div class="folovid__col-contenido pt-3 pb-2 mx-auto px-3 text-start">
      <p class="folovid__texto mb-0 ps-1">Mis dosis</p>

      <div class="folovid__row-dosis">
        <div class="row justify-content-center mt-3" v-if="ListVacunasUsuario">
          <!-- Loop card dosis -->
          <div
            class="col-lg-11 col-md-11 col-11 card-dosis"
            v-for="vacuna in ListVacunasUsuario"
            :key="vacuna.id_vacuna"
          >
            <div
              class="
                row
                card-dosis__row
                justify-content-center
                align-items-center
              "
            >
              <div class="col-lg-10 col-md-10 col-9 text-start card-dosis__col">
                <p class="card-dosis__texto mb-0">{{ vacuna.numero_dosis }}</p>
                <p class="card-dosis__texto-secundario mb-0" :style="{ color: colorPrimario }">
                  Vacuna {{ vacuna.tipo_vacuna.nombre }}
                </p>
              </div>
              <div
                class="col-lg-1 col-md-1 col-2 text-center card-dosis__col px-0"
              >
                <div class="dropstart desplegable-dosis">
                  <button
                    class="desplegable-dosis__boton dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src="@/assets/img/intranet/folovid/3-puntos-vertical.svg"
                      class="desplegable-dosis__icono-opciones"
                      width="4px"
                      alt="Botón Home"
                    />
                  </button>
                  <ul class="dropdown-menu desplegable-dosis__menu">
                    <li>
                      <button
                        class="dropdown-item desplegable-dosis__item"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-editar-dosis"
                        @click="abrirModalEditar(vacuna)"
                      >
                        Editar
                      </button>
                    </li>
                    <li>
                      <button
                        class="dropdown-item desplegable-dosis__item"
                        type="button"
                        @click="borrarVacuna(vacuna.id_vacuna)"
                      >
                        Eliminar
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Loop card dosis -->
        </div>
      </div>

      <div class="row folovid__row justify-content-center mt-3">
        <div class="col-11 folovid__col text-end">
          <button
            class="folovid__boton boton-pill boton-pill--fondo-lila px-3 py-1"
            data-bs-toggle="modal"
            data-bs-target="#modal-add-dosis"
            :style="{ backgroundColor: colorPrimario }"
          >
            Añadir dosis
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { gql } from "graphql-tag";
import { mapState ,mapActions } from "vuex";
// const DeleteVacuna = gql`
//   mutation ($id_vacuna: String!) {
//     DeleteVacuna(id_vacuna: $id_vacuna, id_empresa: "1", id_usuario: "1") {
//       id_vacuna
//     }
//   }
// `;

export default {
  name: "MisDosis",
  data() {
    return {
      //
    };
  },
  computed:{
      ...mapState("FolovidModule", ["ListVacunasUsuario"]),
  },
  created() {
    this.getListaVacunas();
  },
  methods: {
    ...mapActions("FolovidModule", ["getListaVacunasUsuario", "eliminarVacunaUsuario"]),
    async getListaVacunas(){
      let data_ = {
        id_usuario: this.$ls.get("user").id_usuario,
        id_empresa: this.$ls.get("user").id_empresa_fk,
      }
      await this.getListaVacunasUsuario(data_);
    },
    async borrarVacuna(id_vacuna) {
        let data_ = {
          id_usuario: this.$ls.get("user").id_usuario,
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_vacuna: id_vacuna
        }
        await this.eliminarVacunaUsuario(data_).then(resultado=>{
            if(resultado){
              this.$root.$emit("refresh-dosis");
            }
        });
    },
    refreshDosis() {
      this.$apollo.queries.ListVacunasUsuario.refetch();
    },
    abrirModalEditar(vacuna) {
      this.$root.$emit("abrir-modal-editar", vacuna);
    },
  },
  mounted() {
    this.$root.$on("refresh-dosis", () => {
      //this.refreshDosis();
    });
  },
  // apollo: {
  //   ListVacunasUsuario: {
  //     query: gql`
  //       query ListVacunasUsuario($id_usuario: String!) {
  //         ListVacunasUsuario(id_empresa: "1", id_usuario: $id_usuario) {
  //           id_vacuna
  //           numero_dosis
  //           fecha_dosis
  //           fecha_siguiente_dosis
  //           url_imagen
  //           tipo_vacuna {
  //             id_tipo
  //             nombre
  //           }
  //         }
  //       }
  //     `,
  //     variables() {
  //       return {
  //         id_usuario: "1",
  //       };
  //     },
  //   },
  // },
};
</script>